import qs from 'query-string';
import { memo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { LoadingScreen } from '@didaskill/ui/domain';

import { useAuth } from '../../context/auth-context';
import routes from '../../routes';

type AuthGuardProps = {
  children: React.ReactNode;
};

const AuthGuardBase = ({ children }: AuthGuardProps): React.ReactNode => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return (
      <Navigate
        to={{
          pathname: routes.LOGIN.ROOT,
          search: qs.stringify({
            origin: `${location.pathname}${location.search || ''}`,
          }),
        }}
        replace
      />
    );
  }

  return children;
};

export const AuthGuard = memo(AuthGuardBase);
